import { formatCurrency } from '../lib/format';
import type { BreakdownLine } from '../lib/calculate';

interface BreakdownTableProps {
  rows: BreakdownLine[];
}

/**
 * Renders the line-by-line tax math. Amounts that already carry a sign
 * (e.g. -6,500 for a deduction) are passed through. Plain amounts get a
 * leading "$".
 */
export function BreakdownTable({ rows }: BreakdownTableProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <table className="w-full text-sm">
        <tbody>
          {rows.map((row, idx) => {
            const isFinal = row.variant === 'final';
            const isSubtotal = row.variant === 'subtotal';
            const tone = isFinal
              ? 'font-semibold text-base'
              : isSubtotal
              ? 'text-slate-700'
              : 'text-slate-600';
            const cellBg = isSubtotal
              ? 'bg-slate-50'
              : isFinal
              ? 'bg-brand-50'
              : idx % 2 === 0
              ? 'bg-white'
              : 'bg-slate-50/50';

            return (
              <tr key={`${row.label}-${idx}`} className={cellBg}>
                <td className={`px-4 py-2.5 ${tone}`}>{row.label}</td>
                <td
                  className={`px-4 py-2.5 text-right font-mono tabular-nums ${tone}`}
                >
                  {row.amount < 0
                    ? `(${formatCurrency(Math.abs(row.amount))})`
                    : formatCurrency(row.amount)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}